import React from 'react';
import image from '../../res/image';

const ClickSwitch = ({ flag, className, onChange }) => {

  return (
    <div
      className={
        className === undefined ? 'pos-element-block-content-img' : className
      }>
      <img
        style={{ display: 'inline' }}
        onClick={() => {
          onChange(!flag);
        }}
        src={flag ? image.onBtnIcon : image.offBtnIcon}
        alt=""
        className="pos-element-block-content-img-file"
      />
    </div>
  );
};

export default ClickSwitch;
